// Ícones de início (círculo) e fim (seta) de um path.
const icons = [{
  icon: {
    // eslint-disable-next-line
    path: google.maps.SymbolPath.CIRCLE,
    scale: 10,
    strokeColor: '#000',
    strokeWeight: 2,
    fillOpacity: 1,
    fillColor: '#0f0'
  },
  offset: '0%',
}, {
  icon: {
    path: 'M 0 -16 L -12 8 L 0 0 L 12 8 Z',
    scale: 1,
    strokeColor: '#000',
    strokeWeight: 2,
    fillOpacity: 1,
    fillColor: '#0f0'
  },
  offset: '100%',
}]

const styleLower = {
  strokeColor: '#000',
  strokeOpacity: 1.0,
  strokeWeight: 9,
  zIndex: 99,
  icons: icons
}

const styleUpper = {
  strokeColor: '#0f0',
  strokeOpacity: 1.0,
  strokeWeight: 6,
  zIndex: 100
}

export default class DirectedPath {
  constructor(omap) {
    // eslint-disable-next-line
    this.lineLower = new google.maps.Polyline(styleLower)
    // eslint-disable-next-line
    this.lineUpper = new google.maps.Polyline(styleUpper)

    this.omap = omap
    this.omap.addObject(this.lineLower)
    this.omap.addObject(this.lineUpper)
  }

  setPoints(points) {
    this.lineUpper.setPath(points)
    this.lineLower.setPath(points)
    return this
  }

  // não usado; a ideia era fazer track neste
  // próprio objeto
  setMap(map) {
    this.map = map
    this.lineUpper.setMap(map)
    this.lineLower.setMap(map)
    return this
  }

}
